import React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import { SCard } from 'common/modules/printing/styles/Card';
import DateRangePicker from 'common/components/DateRangePicker';
import { formatDays } from 'common/domain/week';
import { DAY_RENDER_FORMAT, DayOfWeek } from 'common/domain/DayOfWeek';

import type { DateRange, Interval } from '../../../domain/reach';
import { getIntervals } from '../components/TimeIntervalChooser';

const ParametersWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: ${({ theme }) => theme.metrics.smallMargin}px;
  font-size: ${({ theme }) => theme.fonts.style.sub.fontSize}px;
`;

const DatesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
`;

const TimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

const TimeParameterWrapper = styled.div`
  display: flex;
`;

const TimeParameterTitle = styled.span`
  display: inline-flex;
  align-items: center;
  width: 90px;
  font-weight: ${({ theme }) => theme.fonts.weights.bolder};
`;

const formatHours = (interval: Interval, t: any) => {
  return `${interval.from.format('LT')} ${t('to')} ${interval.to.format('LT')}`;
};

type Props = {
  dateRange: DateRange;
  dateRangeCompared: ?DateRange;
  interval: Interval;
  days: Array<DayOfWeek>;

  theme: any;
  t: any;
}

function MetricsPrintingParametersCard(props: Props) {
  const { theme, t, dateRange, dateRangeCompared, interval, days } = props;

  return (
    <SCard>
      <ParametersWrapper>
        <DatesWrapper>
          <DateRangePicker from={dateRange.from} to={dateRange.to} disabled fontSize={18} />
          {dateRangeCompared &&
          <React.Fragment>
            <span style={{ fontSize: 15 }}>{t('comparedTo')}</span>
            <DateRangePicker from={dateRangeCompared.from} to={dateRangeCompared.to} disabled fontSize={18} />
          </React.Fragment>
          }
        </DatesWrapper>
        <TimeWrapper style={{ color: theme.colors.primaryText }}>
          <TimeParameterWrapper>
            <TimeParameterTitle>{t('days')} :</TimeParameterTitle>
            <span style={{ maxWidth: 300 }}>{formatDays(days, {
              separator: ', ',
              format: DAY_RENDER_FORMAT.SHORT,
            })}</span>
          </TimeParameterWrapper>
          <TimeParameterWrapper>
            <TimeParameterTitle>{t('hours')} :</TimeParameterTitle>
            <span>{formatHours(interval, t)}</span>
          </TimeParameterWrapper>
          <TimeParameterWrapper>
            <TimeParameterTitle>{t('interval')} :</TimeParameterTitle>
            <span>{getIntervals(t)[interval.step]}</span>
          </TimeParameterWrapper>
        </TimeWrapper>
      </ParametersWrapper>
    </SCard>
  );
}

export default translate('metrics')(withTheme(MetricsPrintingParametersCard));



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/printing/MetricsPrintingParametersCard.js